const mockUser = {
  id: 1,
  name: "John Doe",
  email: "john.doe@example.com",
  points: 100,
};

const POINTS_CONFIG = {
  ADD_RECOMMENDATION: 50,
  RECEIVE_LIKE: 10,
  SHARE_PARKING_PER_HOUR: 25,
  PARKING_COST_PER_DAY: 100,
};

module.exports = {
  mockUser,
  POINTS_CONFIG,
};
